export default __webpack_public_path__ + "images/219417a2e34f2fb094be9dee227915f6.svg";